import axiosSso from "@/api/interceptor_sso";

// 直客列表
export function getClients(params?: any) {
  return axiosSso.get("/agent/clients", { params });
}

// 免密登录
export function postClientsSafeLogin(data: any) {
  return axiosSso.post(`/agent/clients/safe-login`, data);
}